export default __webpack_public_path__ + "static/media/prize-1-cn.e31f8d29.webp";